import { Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import { DealStepEnum,DealStatusEnum } from '../../_enums/_index';
import { DealsWizardModel, SavePageRequestModel, ServiceTypeModel } from '../../_models/_index';
import { DealService } from '../../services/deal.service';
import { InfraService } from '../../services/_index';
import { UserService } from '../../services/user.service';
import { GeneralService } from '../../services/general.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import {
    ActivatedRoute, Router, NavigationStart, RoutesRecognized, RouteConfigLoadStart, RouteConfigLoadEnd,
    NavigationEnd, ActivationEnd, ChildActivationEnd,NavigationCancel,NavigationError,NavigationExtras
} from '@angular/router';

@Component({
  selector: 'deal-wizard',
  templateUrl: './deal-wizard.component.html',
  styleUrls: ['./deal-wizard.component.css']
})
export class DealWizardComponent implements OnInit, OnChanges {
    hasError: boolean = false;
    errorMessage: string;
    loading: boolean=false;
    dealID: number;
    showPaymentStep: boolean = false;
    dealKey: string;
    dealStep: DealStepEnum;
    dealsWizard: DealsWizardModel;
    private height: number;
    serviceTypeList: ServiceTypeModel[];    
    //selected2: ServiceTypeModel;

    constructor(private generalService: GeneralService,
        private userService: UserService,
        private dealService: DealService
        , private route: ActivatedRoute,
        private infraService: InfraService,
        private router: Router
        
    ) {
        this.router.events
            .filter((event) => event instanceof RouteConfigLoadEnd)
            .subscribe((event) => {
                console.log('RouteConfigLoadEnd:', event);
            });

        this.loadServiceType();
    }

    ngOnInit() {                 
        this.loadDeal();
        this.generalService.setIsDirty('false');
    }

  

    ngOnDestroy() {
        this.router.setUpLocationChangeListener();
    }

    isCustomer() {
        return this.userService.isCustomer();
    }
       

    loadDeal() {
        
        if (this.dealsWizard && this.dealsWizard.id >= 0) {
           
            
            this.dealService.getDealByDealKey(this.dealsWizard.dealKey, this.dealsWizard.serviceTypeID  )
                .then(result => {
                    if (result == null) {
                        this.hasError = true;
                        this.errorMessage = 'תקלה-פנה למנהל המערכת';
                        //this.router.navigate(['home/error']);
                        return;
                    }

                    if (this.dealsWizard.id == 0)
                        this.dealStep = DealStepEnum.Package;
                    else if (this.showPaymentStep)
                        this.dealStep = DealStepEnum.Payment;
                    

                    if (result && this.dealKey == result.dealKey || this.dealsWizard.id == 0)
                    {
                        this.dealsWizard = result;
                        this.dealsWizard.serviceTypeID = this.dealsWizard.serviceTypeID ? this.dealsWizard.serviceTypeID : this.serviceTypeList[0].id;
                        this.savePageNumberAndStatus();
                    }
                    else {
                        this.hasError = true;
                        this.errorMessage = 'תקלה-פנה למנהל המערכת';
                        //this.router.navigate(['home/error']);
                        return;
                    }

                    if (result.statusID == DealStatusEnum.Signed && this.userService.isCustomer())
                    {
                        this.hasError = true;
                        this.errorMessage = 'קישור לא פעיל';
                        //this.router.navigate(['home/perm-error',"קישור לא פעיל"]);
                        return;
                    }
                });

            if (this.dealsWizard.id == 0 && !this.userService.isUserLoggedIn()) {
                this.router.navigate(['login']);
                
            }
        }
    }

    initialize() {
        this.route.params.subscribe(params => {
            //console.log(params);
            if (params["key"] != null)
            {
                this.dealKey = params["key"];

                this.dealsWizard.dealKey = this.dealKey;
            }

            if (params["id"] >= 0)
            {
                this.dealID = params["id"];
                this.dealsWizard.id = this.dealID;

                if (params["pay"] != null) {
                    this.showPaymentStep = params["pay"] == "False" ? false : true;
                }

                this.loadDeal();
            }

            
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log('changed');
    }

    savePageNumber(dealStep:number)
    {
        if (this.dealsWizard && this.userService.isCustomer() && (this.dealsWizard.statusID == DealStatusEnum.Opened || this.dealsWizard.statusID == DealStatusEnum.Sent))
        {
            let request: SavePageRequestModel = new SavePageRequestModel();
            request.dealID = this.dealID;
            request.pageNumber = dealStep;
            this.dealService.savePageNumber(request);
        }
    }

    savePageNumberAndStatus()
    {
        if (this.dealsWizard && this.userService.isCustomer() && this.dealsWizard.statusID == DealStatusEnum.Sent) {
            let request: SavePageRequestModel = new SavePageRequestModel();
            request.dealID = this.dealID;
            request.pageNumber = DealStepEnum.Package;
            request.statusID = DealStatusEnum.Opened;
            this.dealService.saveStatus(request);
        }
    }

    nextStepClicked(dealStep: DealStepEnum) {
        if (this.dealStep < dealStep)
            this.savePageNumber(dealStep);
        this.dealStep = dealStep;

        
            this.generalService.setIsDirty('true');
        
    }

    keyboardShown(e) {
        
    }

    saveOrder(event: DealsWizardModel) {
        this.loading = true;
        if (!this.dealsWizard.isTrial && this.dealsWizard.creditCardNumber && this.dealsWizard.creditCardToken==null) {
            this.dealService.checkCreditCardInput(event).then(result => {
                
                if (result) {
                    let companyFile = this.dealsWizard.fileToUpload;
                    this.dealsWizard = result;
                    this.dealsWizard.fileToUpload = companyFile;
                    if (result.hasError) {
                        this.generalService.showErrorDialog(result.errorMessage);
                        this.loading = false;
                    }
                    else {
                        setTimeout(() => {
                            this.saveDeal();
                        }, 2);
                    }
                }
                else {
                    this.generalService.showErrorDialog('לא ניתן לבצע השלמת הזמנה !');
                    this.loading = false;
                }
            });
        }
        else
            this.saveDeal();
    }

    saveDeal() {

        if (this.userService.isCustomer()) {
            if (this.dealsWizard.statusID == DealStatusEnum.Opened || this.dealsWizard.statusID==DealStatusEnum.Sent)
                this.dealsWizard.statusID = DealStatusEnum.Signed;
        }
       
        this.dealService.saveDeal(this.dealsWizard).then(result => {
            this.afterSave(result);
        });
    }

    afterSave(result: DealsWizardModel) {
        if (result) {
            if (this.dealsWizard.fileToUpload)
                setTimeout(() => {
                    this.uploadCompanySignatureFile(result.dealKey);
                }, 2);
                
            else {
                this.sendPDF();
            }
        }
        else {
            this.generalService.showErrorDialog('לא ניתן לבצע השלמת הזמנה !');
            this.loading = false;
        }
    }

    sendPDF()
    {
        if (this.userService.isCustomer() && this.dealsWizard.statusID == DealStatusEnum.Signed) {
            this.dealService.sendDealPDF(this.dealsWizard.dealKey, this.dealsWizard.email, this.dealsWizard.companyName,this.dealsWizard.serviceTypeID).then(result => {
                this.dealStep = DealStepEnum.Welcome;
                this.loading = false;
                this.generalService.setIsDirty('false');
            });
        }
        else
        {
            this.dealStep = DealStepEnum.Welcome;
            this.loading = false;
            this.generalService.setIsDirty('false');
        }
    }

    uploadCompanySignatureFile(dealKey: string) {
        this.dealService.makeFileRequest("deals/uploadCompanySignatureFile?jsonStringDeal=" + "{'dealKey':'" + dealKey + "'}", this.dealsWizard.fileToUpload).then((result) => {
            
            if (result) {
                this.sendPDF();
               
            } else {
                this.generalService.showErrorDialog("ארעה תקלה");
                this.loading = false;
            }
        }, (error) => {

            this.generalService.showErrorDialog("ארעה תקלה");
            this.loading = false;
        });
    }

    loadServiceType() {
        if (this.isCustomer()) {
            this.dealsWizard = new DealsWizardModel();
            this.dealStep = DealStepEnum.Package;
            this.initialize();
        }
        else {
            this.infraService.getServiceType().then(result => {
                this.serviceTypeList = result;
                
                this.dealsWizard = new DealsWizardModel();
                //this.selected2 = this.serviceTypeList[0];
                this.dealsWizard.serviceTypeID = this.dealsWizard.serviceTypeID ? this.dealsWizard.serviceTypeID : this.serviceTypeList[0].id;
                this.dealStep = DealStepEnum.Package;
                this.initialize();
            });
        }
    }

    serviceTypeChanged(serviceTypeID:number) {
        debugger;
        

        this.dealService.getDealByDealKey(this.dealsWizard.dealKey, serviceTypeID)
            .then(result => {
                debugger;
                if (result != null) {
                    var temp = serviceTypeID;

                    this.dealsWizard = result;
                    this.dealsWizard.serviceTypeID = temp;

                }
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-wizard.component.ts